import styled from 'styled-components';

export const Content = styled.div`
    height: calc(100% - 100px);
    overflow-y: auto;
`;

export const ButtonDiv = styled.div`
    align-items: center;
    display: flex;
    height: 100px;
    justify-content: center;
`;
